import gql from 'graphql-tag';
//agregar fecha de vigencia para apis
export const queryLlaves = gql`
   query Cliente($codigoCliente: String!) {
      llavesNoAnuladas(codigo: $codigoCliente) {
         codigo
         documento
         fechaExpiracion
         producto
         iter
      }
   }
`;

export const queryData = gql`
   query DATA {
      presentaciones {
         codigo
         denominacion
      }
      productos {
         codigo
         denominacion
      }
      versiones {
         codigo
         denominacion
      }
      modulares {
         codigo
         codigoProducto
         denominacion
      }
   }
`;

export const queryDataVer = gql`
   query DATA($codigoProducto: String) {
      productoDetallesOrdDesFechaCreacion(codigoProducto: $codigoProducto) {
         version {
            codigo
            denominacion
         }
         presentacion {
            codigo
            denominacion
         }
      }
   }
`;

export const mutationGenerarLicencia = gql`
   mutation GenerarLicencias(
      $ruc: String!
      $razonsocial: String!
      $tipoDoc: String!
      $serieDoc: String!
      $nroDoc: String!
      $usuario: String!
      $activaciones: [GenerarLicenciaInput]!
   ) {
      generarLicencia(
         ruc: $ruc
         razonsocial: $razonsocial
         tipoDoc: $tipoDoc
         serieDoc: $serieDoc
         nroDoc: $nroDoc
         usuario: $usuario
         activaciones: $activaciones
      ) {
         msg
      }
   }
`;
